import { cn } from '@/lib/utils';
import * as React from 'react';
import styles from './Alert.module.css';
import {
    faCheck,
    faExclamation,
    faExclamationTriangle,
    faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface AlertProps {
    title?: string;
    description?: string;
    variant?: 'default' | 'destructive' | 'success' | 'warning';
    children?: React.ReactNode;
    onClose?: () => void;
    timed?: boolean;
}

const Alert: React.FC<AlertProps> = ({
    title,
    description,
    variant = 'default',
    children,
    onClose,
    timed = false,
}) => {
    const [isOpen, setIsOpen] = React.useState(true);

    React.useEffect(() => {
        if (timed) {
            setTimeout(() => {
                setIsOpen(false);
            }, 3000);
        }
    }, [timed]);

    return (
        isOpen && (
            <div role="alert" className={`${styles[variant]} ${styles.alert}`}>
                <div className={styles.title}>
                    {variant === 'default' && (
                        <FontAwesomeIcon icon={faExclamation} />
                    )}
                    {variant === 'destructive' && (
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                    )}
                    {variant === 'success' && (
                        <FontAwesomeIcon icon={faCheck} />
                    )}

                    {title && <h6>{title}</h6>}
                    {onClose && (
                        <div className={styles.close}>
                            <FontAwesomeIcon
                                icon={faXmark}
                                onClick={onClose}
                                className={styles.close}
                            />
                        </div>
                    )}
                </div>
                {description && <div>{description}</div>}
                {children}
            </div>
        )
    );
};

export default Alert;
